/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  completeBatch,
  getBatch,
  getBatchFiles,
  searchBatchFiles,
  hideOwnershipModal,
  showEditCustomerLegalEntitiesModal,
  hideEditCustomerLegalEntitiesModal,
  editCustomerLegalEntities,
  takeQueueItem,
  getBatchFilePdf,
  showDeleteFileModal,
  hideDeleteFileModal,
  deleteBatchFile
} from 'actions';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import BatchBreadcrumbs from 'components/BatchBreadcrumbs';
import BatchFiles from 'components/BatchFiles';
import ChangeOwnershipModal from 'components/Modals/ChangeOwnershipModal';
import ConfirmModal from 'components/Modals/ConfirmModal';
import EditCustomerLegalEntitiesModal from 'components/Modals/EditCustomerLegalEntitiesModal';
import DeleteFileModal from 'components/Modals/DeleteFileModal';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';

const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

class BatchFilesContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.shape().isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    settings: PropTypes.shape(),
    permissions: PropTypes.arrayOf(PropTypes.string),
    isGettingBatchFiles: PropTypes.bool.isRequired,
    batchFiles: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      dateUploaded: PropTypes.string,
      folder: PropTypes.string,
      legalEntity: PropTypes.string,
      businessDivision: PropTypes.string,
      region: PropTypes.string,
      statusString: PropTypes.string,
      numberOfPacks: PropTypes.number,
      numberOfFiles: PropTypes.number
    })),
    batchItem: PropTypes.shape(),
    batchFilesCount: PropTypes.number,
    batchFilesPageNumber: PropTypes.number,
    batchFilesPageSize: PropTypes.number,
    changeOwnershipItem: PropTypes.shape(),
    isOwnershipModalShown: PropTypes.bool,
    isEditCustomerLegalEntitiesModalShown: PropTypes.bool,
    // eslint-disable-next-line
    batchFilePdfData: PropTypes.any,
    batchFileOriginalFileName: PropTypes.string,
    isDeleteFileModalShown: PropTypes.bool,
    isDeletingFile: PropTypes.bool,
    fileId: PropTypes.number,
    deleteFileError: PropTypes.string,
    location: PropTypes.shape({
      key: PropTypes.string
    }).isRequired,
    isCompletingBatch: PropTypes.bool
  };

  static defaultProps = {
    settings: null,
    permissions: null,
    batchItem: null,
    batchFiles: null,
    batchFilesPageNumber: 1,
    batchFilesPageSize: 50,
    batchFilesCount: 0,
    isOwnershipModalShown: false,
    isEditCustomerLegalEntitiesModalShown: false,
    changeOwnershipItem: null,
    batchFilePdfData: null,
    batchFileOriginalFileName: null,
    isDeleteFileModalShown: false,
    isDeletingFile: false,
    deleteFileError: null,
    fileId: 0,
    isCompletingBatch: false
  };

  constructor(props) {
    super(props);
    this.state = {
      searchQuery: null,
      selectionEnabled: false,
      currentPageNumber: props.batchFilesPageNumber,
      currentPageSize: props.batchFilesPageSize,
      isConfirmCompleteBatchModalShown: false,
      confirmBatchItem: null
    };
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillMount() {
    const {
      isAuthenticated,
      batchFilesPageNumber,
      batchFilesPageSize
    } = this.props;
    if (isAuthenticated) {
      this.fetchBatchFiles(batchFilesPageNumber, batchFilesPageSize);
      this.fetchBatchDetails();
    }
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillReceiveProps(newProps) {
    const { batchFilePdfData, batchFileOriginalFileName } = this.props;

    if (batchFileOriginalFileName == null && batchFilePdfData !== newProps.batchFilePdfData && newProps.batchFilePdfData != null) {
      const link = document.createElement('a');
      link.href = newProps.batchFilePdfData;
      link.setAttribute('download', newProps.batchFileOriginalFileName);
      document.body.appendChild(link);
      link.click();
    }
  }

  shouldComponentUpdate({ location: { key: nextKey } }) {
    const {
      location: { key },
      batchFilesPageNumber,
      batchFilesPageSize,
    } = this.props;
    const updateComponent = key !== nextKey;
    if (updateComponent) {
      this.fetchBatchFiles(batchFilesPageNumber, batchFilesPageSize);
    }
    return !updateComponent;
  }

  componentDidUpdate() {
    const { selectionEnabled } = this.state;
    this.batchFilesGrid.setSelectionVisibility(selectionEnabled);
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(hideEditCustomerLegalEntitiesModal());
    dispatch(hideOwnershipModal());
  }

  getCoverSheetMessage() {
    const {
      batchItem
    } = this.props;

    return (batchItem && batchItem.coverSheetJson)
      && (<div>Cover sheet available</div>);
  }

  getRefreshAction(pageNumber, pageSize) {
    const {
      history: {
        location: { pathname }
      }
    } = this.props;
    let batchId = 0;
    const path = pathname.split('/');
    if (path.length >= 2 && path.indexOf('batches') === 1) {
      batchId = path[2];
    }

    const { searchQuery } = this.state;
    let sortModel;
    let filters;
    let actionMethod;
    let actionParameters;
    if (this.batchFilesGrid) {
      sortModel = this.batchFilesGrid.getSortModel();
      filters = this.batchFilesGrid.getFilterModel();
    }

    const sortBy = (sortModel && sortModel[0]) ? sortModel[0].colId : '';
    const sortDirection = (sortModel && sortModel[0]) ? sortModel[0].sort : '';

    if (pageNumber === 'undefined' || !pageNumber) {
      pageNumber = 1;
    }
    if (pageSize === 'undefined' || !pageSize) {
      pageSize = 50;
    }

    actionParameters = [batchId, pageNumber, pageSize, sortBy, sortDirection, filters];
    if (!searchQuery && !sortModel && !filters) {
      actionMethod = getBatchFiles;
    } else {
      actionMethod = searchBatchFiles;
      actionParameters = [...actionParameters, searchQuery];
    }

    return { actionMethod, actionParameters };
  }

  triggerSearch = () => {
    const { currentPageSize } = this.state;
    let { currentPageNumber } = this.state;
    currentPageNumber = 1;
    this.setState({ currentPageNumber });
    this.batchFilesGrid.resetPageNumber(currentPageNumber);

    this.fetchBatchFiles(currentPageNumber, currentPageSize);
  }

  fetchBatchDetails() {
    const {
      dispatch,
      history: {
        location: { pathname }
      }
    } = this.props;
    let batchId = 0;
    const path = pathname.split('/');
    if (path.length >= 2 && path.indexOf('batches') === 1) {
      batchId = path[2];
    }
    if (batchId > 0) {
      dispatch(getBatch(batchId));
    }
  }

  fetchBatchFiles(pageNumber, pageSize) {
    const {
      dispatch,
      history: {
        location: { pathname }
      }
    } = this.props;
    let batchId = 0;
    const path = pathname.split('/');
    if (path.length >= 2 && path.indexOf('batches') === 1) {
      batchId = path[2];
    }

    const { searchQuery } = this.state;
    let sortModel;
    let filters;

    if (this.batchFilesGrid) {
      sortModel = this.batchFilesGrid.getSortModel();
      filters = this.batchFilesGrid.getFilterModel();
    }

    const sortBy = (sortModel && sortModel[0]) ? sortModel[0].colId : '';
    const sortDirection = (sortModel && sortModel[0]) ? sortModel[0].sort : '';

    if (pageNumber === 'undefined' || !pageNumber) {
      pageNumber = 1;
    }
    if (pageSize === 'undefined' || !pageSize) {
      pageSize = 50;
    }

    if (!searchQuery && !sortModel && !filters) {
      dispatch(getBatchFiles(batchId, pageNumber, pageSize, sortBy, sortDirection, filters));
    } else {
      dispatch(searchBatchFiles(batchId, pageNumber, pageSize, sortBy, sortDirection, filters, searchQuery));
    }
  }

  searchChanged(event) {
    clearTimeout(this.timer);
    const searchQuery = event.target.value;

    if (searchQuery.length > 0 && searchQuery.length < 2) {
      return;
    }

    this.setState({
      searchQuery
    });

    this.timer = setTimeout(this.triggerSearch, WAIT_INTERVAL);
  }

  searchInGrid(event) {
    clearTimeout(this.timer);
    const searchQuery = event.target.value;

    if (searchQuery.length > 0 && searchQuery.length < 2) {
      return;
    }

    this.setState({
      searchQuery
    });

    if (event.keyCode === ENTER_KEY) {
      this.triggerSearch();
    } else {
      this.timer = setTimeout(this.triggerSearch, WAIT_INTERVAL);
    }
  }

  changePage(paging) {
    this.setState({
      currentPageNumber: paging.number,
      currentPageSize: paging.size
    });
    this.fetchBatchFiles(paging.number, paging.size);
    return true;
  }

  openConfirmCompleteBatchModal(confirmBatchItem) {
    this.setState({ isConfirmCompleteBatchModalShown: true, confirmBatchItem });
  }

  closeConfirmCompleteBatchModel() {
    this.setState({ isConfirmCompleteBatchModalShown: false });
  }

  completeBatch() {
    const { dispatch } = this.props;
    const { confirmBatchItem } = this.state;
    dispatch(completeBatch(confirmBatchItem.id, getBatch));
    this.setState({ isConfirmCompleteBatchModalShown: false });
  }

  openDeleteFileModal(item) {
    const { dispatch } = this.props;
    dispatch(showDeleteFileModal(item));
  }

  closeDeleteFileModal() {
    const { dispatch } = this.props;
    dispatch(hideDeleteFileModal());
  }

  deleteFile() {
    const { dispatch, fileId, history: { location: { pathname } } } = this.props;
    const { currentPageNumber, currentPageSize } = this.state;

    let batchId = 0;
    const path = pathname.split('/');
    if (path.length >= 2 && path.indexOf('batches') === 1) {
      batchId = path[2];
    }

    dispatch(deleteBatchFile(batchId, fileId, currentPageNumber, currentPageSize));
  }

  openEditCustomerLegalEntitiesModal(item) {
    const { dispatch } = this.props;
    dispatch(showEditCustomerLegalEntitiesModal([item]));
  }

  closeEditCustomerLegalEntitiesModal() {
    const { dispatch } = this.props;
    dispatch(hideEditCustomerLegalEntitiesModal());
  }

  processEditCustomerLegalEntities(customerList, newLegalEntityId) {
    const { dispatch } = this.props;
    const {
      currentPageNumber,
      currentPageSize
    } = this.state;
    dispatch(editCustomerLegalEntities(customerList, newLegalEntityId, currentPageNumber, currentPageSize));
  }

  reAssignItem() {
    const { dispatch, changeOwnershipItem } = this.props;

    if (changeOwnershipItem != null && changeOwnershipItem.id != null) {
      dispatch(takeQueueItem('form', changeOwnershipItem.id));
      dispatch(hideOwnershipModal());
    }
  }

  refreshList() {
    const { dispatch } = this.props;
    const { currentPageNumber, currentPageSize } = this.state;
    const refreshAction = this.getRefreshAction(currentPageNumber, currentPageSize);
    if (refreshAction) {
      dispatch(refreshAction.actionMethod(...refreshAction.actionParameters));
    }
  }

  continueFromOwnershipModal() {
    const { dispatch, history, changeOwnershipItem } = this.props;
    dispatch(hideOwnershipModal());
    history.push(`/forms/${ changeOwnershipItem.formType.toLowerCase() }/${ changeOwnershipItem.id }`);
  }

  closeFromOwnershipModal() {
    const { dispatch } = this.props;
    dispatch(hideOwnershipModal());
  }

  downloadOriginalBatchFile(batchFile) {
    const { dispatch } = this.props;
    dispatch(getBatchFilePdf(batchFile));
  }

  render() {
    const {
      settings,
      permissions,
      isGettingBatchFiles,
      batchItem,
      batchFiles,
      batchFilesCount,
      isOwnershipModalShown,
      isEditCustomerLegalEntitiesModalShown,
      changeOwnershipItem,
      isDeletingFile,
      isDeleteFileModalShown,
      deleteFileError,
      isCompletingBatch
    } = this.props;

    const {
      isConfirmCompleteBatchModalShown,
      confirmBatchItem
    } = this.state;

    return (
      <div className="container home-page-panel">
        <div className="panel col-12 batches-panel">
          <div className="panel-header">
            <div className="panel-title">
              Uploaded Batch Files
              { batchItem && batchItem.id && <BatchBreadcrumbs batchId={ batchItem.id } batchDisplayId={ batchItem.batchId } />}
            </div>
            { this.getCoverSheetMessage() }
            <div>
              <div className="tool-panel">
                <div className="controls-group">
                  <div className="input-group">
                    { AccessControl.hasPermission(permissions, [ActivityPerms.fwfBatchReviewer])
                    && batchItem && batchItem.statusString === 'Processed' && batchItem.numberOfUnassignedForms === 0
                    && <button
                      type="button"
                      className="btn btn-primary mr"
                      onClick={
                        () => this.openConfirmCompleteBatchModal(batchItem)
                      }
                    >
                      Complete Batch
                    </button> }
                    <input
                      type="search"
                      className="form-input"
                      placeholder="Search Batch Files..."
                      ref={ (el) => { this.searchQuery = el; } }
                      onKeyUp={ e => this.searchInGrid(e) }
                      onChange={ e => this.searchChanged(e) }
                    />
                    <span className="input-group-addon">
                      <span className="icon icon-search" />
                    </span>
                    <button id="refresh-button" type="button" className="btn ml" onClick={ () => this.refreshList() }>
                      <span className="icon icon-refresh" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="panel-body">
            <BatchFiles
              settings={ settings }
              permissions={ permissions }
              ref={ (ref) => { this.batchFilesGrid = ref; } }
              isLoading={ isGettingBatchFiles }
              rowData={ batchFiles }
              totalCount={ batchFilesCount }
              changePageCallback={ batchFile => this.changePage(batchFile) }
              editCustomerLegalEntitiesCallback={ batchFile => this.openEditCustomerLegalEntitiesModal(batchFile) }
              downloadOriginalBatchFileCallback={ (batchId, batchFileId) => this.downloadOriginalBatchFile(batchId, batchFileId) }
              deleteFileCallback={ batchFile => this.openDeleteFileModal(batchFile) }
            />
          </div>
        </div>

        { isEditCustomerLegalEntitiesModalShown && <EditCustomerLegalEntitiesModal
          isShown={ isEditCustomerLegalEntitiesModalShown }
          onCancel={ () => this.closeEditCustomerLegalEntitiesModal() }
          onConfirmLegalEntityIdChange={ (customerList, newLegalEntityId) => this.processEditCustomerLegalEntities(customerList, newLegalEntityId) }
        /> }

        { changeOwnershipItem != null && <ChangeOwnershipModal
          isShown={ isOwnershipModalShown }
          onAssign={ () => this.reAssignItem() }
          onContinueWithoutAssign={ () => this.continueFromOwnershipModal() }
          onCancel={ () => this.closeFromOwnershipModal() }
          workflowRecord={ changeOwnershipItem }
        /> }

        { isDeleteFileModalShown && <DeleteFileModal
          isShown={ isDeleteFileModalShown }
          isDeletingForm={ isDeletingFile }
          onConfirmDelete={ () => this.deleteFile() }
          onCancel={ () => this.closeDeleteFileModal() }
          deleteFileError={ deleteFileError }
        /> }

        { isConfirmCompleteBatchModalShown && <ConfirmModal
          key="completeBatch"
          isShown={ isConfirmCompleteBatchModalShown }
          isPerformingAction={ isCompletingBatch }
          onConfirm={ () => this.completeBatch() }
          onCancel={ () => this.closeConfirmCompleteBatchModel() }
          title="Confirm Complete Batch"
          message={ `Are you sure you want to complete the batch ${ confirmBatchItem.batchId }?` }
        /> }

      </div>
    );
  }
}

function mapStateToProps(state) {
  if (!state.auth) {
    return {};
  }

  const {
    auth: {
      isAuthenticated,
      settings,
      permissions
    },
    batches: {
      batchItem,
      isCompletingBatch
    },
    batchFiles: {
      isGettingBatchFiles,
      batchFiles,
      batchFilesCount,
      batchFormToEdit,
      editLegalEntityError,
      batchFilePdfData,
      batchFileOriginalFileName,
      isDeleteFileModalShown,
      isDeletingFile,
      deleteFileError,
      fileId
    },
    forms: {
      isEditCustomerLegalEntitiesModalShown
    },
    workflow: {
      isOwnershipModalShown,
      changeOwnershipItem
    }
  } = state;

  return {
    isAuthenticated,
    settings,
    permissions,
    isGettingBatchFiles,
    batchItem,
    batchFiles,
    batchFilesCount,
    batchFormToEdit,
    editLegalEntityError,
    isOwnershipModalShown,
    changeOwnershipItem,
    isEditCustomerLegalEntitiesModalShown,
    batchFilePdfData,
    batchFileOriginalFileName,
    isDeleteFileModalShown,
    isDeletingFile,
    deleteFileError,
    fileId,
    isCompletingBatch
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(BatchFilesContainer, 'BatchFilesContainer')));
